import { useState } from "react"
import { Dropdown, Nav, Col } from "react-bootstrap"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faEllipsisVertical,
  faPhone,
  faEnvelope,
  faMapMarkerAlt,
  faStar,
  faUser,
  faStarHalfAlt,
  faUserTie,
} from "@fortawesome/free-solid-svg-icons"
import { faStar as faRegStar } from "@fortawesome/free-regular-svg-icons"
import { Pagination } from "./Pagination"
import { maskContactNumber } from "../Utils/helpers/commonhelper"
const getInitials = (companyName) => {
  const words = companyName.split(" ")
  if (words.length < 2) {
    return companyName?.charAt(0).toUpperCase() || " "
  }
  return (words[0][0] + words[1][0]).toUpperCase()
}

export const CompanyCardView = ({
  dataToDisplay,
  baseURL,
  setSelectedCompanyId,
  setShowCompanyDetails,
  fetchCompanyDetails,
  setConfirmDeleteId,
  renderCompanyRow,
  profile,
  setLimit,
  setOffset,
  offset,
  limit,
  handlePageChange,
  pageCount,
}) => {
  return (
    <>
      <div className="row g-4" style={{ marginBottom: "10px" }}>
        {dataToDisplay.map((company) => {
          const { primaryEmail, primaryPhone } = renderCompanyRow(company, 0)

          // Assuming these keys exist in your company object for social links
          const facebookUrl = company.facebook || ""

          return (
            <Col xxl={3} xl={4} md={6} key={company.id}>
              <div className="card border h-100">
                <div className="card-body d-flex flex-column p-2">
                  {/* Header Section */}
                  <div className="d-flex align-items-center justify-content-between mb-3 pb-3 border-bottom row-gap-2">
                    <div
                      className="d-flex align-items-center flex-grow-1 me-2"
                      style={{ minWidth: 0 }}
                    >
                      <a
                        href="#"
                        className="avatar border rounded-circle flex-shrink-0 me-2"
                        onClick={(e) => {
                          e.preventDefault()
                          setSelectedCompanyId(company.id)
                          setShowCompanyDetails(true)
                        }}
                        style={{
                          width: "48px",
                          height: "48px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          overflow: "hidden",
                          backgroundColor: "#7a3a5e",
                        }}
                      >
                        {company.company_image ? (
                          <img
                            src={`${baseURL}${company.company_image}`}
                            alt={company.company_name}
                            className="w-auto h-auto"
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                              //   backgroundColor: "#7a3a5e",
                            }}
                          />
                        ) : (
                          <span className="text-white fw-bold">
                            {getInitials(company.company_name)}
                          </span>
                        )}
                      </a>
                      <div style={{ minWidth: "0.5rem", flex: 1 }}>
                        <h6 className="fs-16 mb-1">
                          <a
                            href="#"
                            className="fw-medium text-decoration-none text-truncate d-block"
                            style={{ color: "inherit" }}
                            onClick={(e) => {
                              e.preventDefault()
                              setSelectedCompanyId(company.id)
                              setShowCompanyDetails(true)
                            }}
                          >
                            {company.company_name || "-"}
                          </a>
                        </h6>
                        {/* <div className="d-flex align-items-center">
                          <FontAwesomeIcon
                            icon={faStar}
                            className="text-warning me-1"
                            style={{ fontSize: "12px" }}
                          />
                          <span
                            className="text-muted"
                            style={{ fontSize: "13px" }}
                          >
                            {company.rating || "0.0"}
                          </span>
                        </div> */}
                        <div className="d-flex align-items-center">
                          {[...Array(5)].map((_, index) => {
                            const number = index + 0.5
                            return (
                              <span key={index}>
                                {company.rating >= index + 1 ? (
                                  <FontAwesomeIcon
                                    icon={faStar}
                                    className="text-warning me-1"
                                    style={{ fontSize: "12px" }}
                                  />
                                ) : company.rating >= number ? (
                                  <FontAwesomeIcon
                                    icon={faStarHalfAlt}
                                    className="text-warning me-1"
                                    style={{ fontSize: "12px" }}
                                  />
                                ) : (
                                  <FontAwesomeIcon
                                    icon={faRegStar}
                                    className="text-warning me-1"
                                    style={{ fontSize: "12px" }}
                                  />
                                )}
                              </span>
                            )
                          })}

                          {/* <span
                            className="text-muted ms-1"
                            style={{ fontSize: "13px" }}
                          >
                            {company.rating || "0.0"}
                          </span> */}
                        </div>
                      </div>
                    </div>

                    {/* Dropdown Menu */}
                    <Dropdown as="div" align="end">
                      <Dropdown.Toggle
                        as={Nav.Link}
                        className="action-icon btn btn-icon btn-sm btn-outline-light border p-1 no-arrow"
                        style={{ cursor: "pointer" }}
                      >
                        <style jsx>
                          {`
                            .no-arrow::after {
                              display: none !important;
                            }
                          `}
                        </style>
                        <FontAwesomeIcon
                          icon={faEllipsisVertical}
                          style={{ fontSize: "14px", color: "#536485" }}
                        />
                      </Dropdown.Toggle>
                      <Dropdown.Menu
                        className="shadow-sm"
                        style={{ minWidth: "140px" }}
                      >
                        <Dropdown.Item
                          onClick={() => fetchCompanyDetails(company.id)}
                          style={{ fontSize: "13px", padding: "6px 16px" }}
                        >
                          Edit
                        </Dropdown.Item>
                        <Dropdown.Item
                          onClick={() => setConfirmDeleteId(company.id)}
                          style={{ fontSize: "13px", padding: "6px 16px" }}
                        >
                          Delete
                        </Dropdown.Item>
                        <Dropdown.Item
                          onClick={(e) => {
                            e.preventDefault()
                            setSelectedCompanyId(company.id)
                            setShowCompanyDetails(true)
                          }}
                          style={{ fontSize: "13px", padding: "6px 16px" }}
                        >
                          View Details
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>

                  {/* Contact Information */}
                  <div className="d-block mb-1 mx-1">
                    <div className="d-flex flex-column mb-0">
                      <p
                        className="text-muted d-inline-flex align-items-center mb-2"
                        style={{ fontSize: "12px" }}
                      >
                        <FontAwesomeIcon
                          icon={faEnvelope}
                          className="text-dark me-2 flex-shrink-0"
                          style={{ fontSize: "14px" }}
                        />
                        <span className="text-truncate">
                          {primaryEmail ?? "-"}
                        </span>
                      </p>
                      <p
                        className="text-muted d-inline-flex align-items-center mb-2"
                        style={{ fontSize: "12px" }}
                      >
                        <FontAwesomeIcon
                          icon={faPhone}
                          className="text-dark me-2 flex-shrink-0"
                          style={{ fontSize: "14px" }}
                        />
                        {/* <span>{primaryPhone ?? "-"}</span> */}
                        <span
                          style={{
                            letterSpacing: "0.25px",
                            whiteSpace: "nowrap",
                          }}
                        >{maskContactNumber(primaryPhone) ?? "-"}</span>
                      </p>
                      <p
                        className="text-muted d-inline-flex align-items-center mb-0"
                        style={{ fontSize: "12px" }}
                      >
                        <FontAwesomeIcon
                          icon={faMapMarkerAlt}
                          className="text-dark me-2 flex-shrink-0"
                          style={{ fontSize: "14px" }}
                        />
                        <span>{`${company.city_name ?? "-"}, ${company.state_name ?? "-"
                          }, ${company.nicename ?? "-"}`}</span>
                      </p>
                    </div>
                  </div>

                  {/* Footer: Social Links + Avatar */}
                  <div className="d-flex justify-content-between align-items-center  row-gap-2 border-top pt-3 mt-auto mx-">
                    <div className="d-flex align-items-center grid-social-links">
                      {/* Email Link */}
                      <a
                        href={primaryEmail ? `mailto:${primaryEmail}` : "#"}
                        className={`avatar avatar-xs rounded-circle me-1 ${primaryEmail ? "text-dark" : "text-muted"
                          }`}
                        onClick={(e) => !primaryEmail && e.preventDefault()}
                        title={primaryEmail || "No email available"}
                        style={{
                          width: "28px",
                          height: "28px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          cursor: primaryEmail ? "pointer" : "default",
                        }}
                      >
                        <FontAwesomeIcon
                          icon={faEnvelope}
                          style={{ fontSize: "14px" }}
                        />
                      </a>

                      {/* Phone Link */}
                      <a
                        href={primaryPhone ? `tel:${primaryPhone}` : "#"}
                        className={`avatar avatar-xs rounded-circle me-1 ${primaryPhone ? "text-dark" : "text-muted"
                          }`}
                        onClick={(e) => !primaryPhone && e.preventDefault()}
                        title={primaryPhone || "No phone available"}
                        style={{
                          width: "28px",
                          height: "28px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          cursor: primaryPhone ? "pointer" : "default",
                        }}
                      >
                        <FontAwesomeIcon
                          icon={faPhone}
                          style={{ fontSize: "14px" }}
                        />
                      </a>

                      {/* Message/Generic Link (Optional - left as placeholder or can be mapped to SMS) */}
                      {/* <a
                        href="#"
                        className="avatar avatar-xs text-muted rounded-circle me-1"
                        onClick={(e) => e.preventDefault()}
                        style={{
                          width: "28px",
                          height: "28px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <i
                          className="ti ti-message-circle-share"
                          style={{ fontSize: "14px" }}
                        ></i>
                      </a> */}

                      {/* Facebook Link */}
                      <a
                        href={facebookUrl || "#"}
                        target={facebookUrl ? "_blank" : "_self"}
                        rel="noopener noreferrer"
                        className={`avatar avatar-xs rounded-circle ${facebookUrl ? "text-dark" : "text-muted"
                          }`}
                        onClick={(e) => !facebookUrl && e.preventDefault()}
                        title={facebookUrl || "No Facebook link"}
                        style={{
                          width: "28px",
                          height: "28px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          cursor: facebookUrl ? "pointer" : "default",
                        }}
                      >
                        <i
                          className="ti ti-brand-facebook"
                          style={{ fontSize: "14px" }}
                        ></i>
                      </a>
                    </div>

                    {/* Assigned User Avatar */}
                    <div className="d-flex align-items-center mt-2 me-1">
                      <span className="avatar avatar-xs border-0">
                        <img
                          src={
                            `${baseURL}${company.profile_img}` ?? `${profile}`
                          }
                          alt="Assigned user"
                          className="rounded-circle"
                          onError={(e) => {
                            e.target.style.display = "none" // Hide broken image
                            // You can add logic here to show a gender icon if image fails
                          }}
                          style={{
                            width: "35px",
                            height: "35px",
                            objectFit: "cover",
                          }}
                        />
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          )
        })}
        {dataToDisplay?.length >= 8 && (
          <div
            style={{
              padding: "0.5rem 0",
              backgroundColor: "white",
              borderTop: "1px solid #e0e0e0",
              overflowX: "auto",
              width: "100%",
            }}
          >
            <div className="d-flex justify-content-between align-items-center gap-2">
              <div className="pagination-left">
                <p className="mb-0" style={{ fontSize: "14px" }}>
                  Showing {offset + 1} of{" "}
                  {pageCount !== 0 ? pageCount : pageCount + 1}
                </p>
              </div>
              <div className="pagination-right d-flex gap-2 align-items-center">
                <select
                  style={{ minWidth: "78px", height: "2.3rem" }}
                  onChange={(e) => {
                    setLimit(Number(e.target.value))
                    setOffset(0)
                  }}
                  id="limit"
                  className="form-control form-select"
                >
                  <option value={24}>24</option>
                  <option value={100}>100</option>
                  <option value={200}>200</option>
                  <option value={300}>300</option>
                </select>
                <div className="d-flex align-items-center gap-3">
                  <Pagination
                    offset={offset}
                    setOffset={setOffset}
                    handlePageChange={handlePageChange}
                    pageCount={pageCount}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  )
}
